import { useEffect } from "react";

/**
 * Scrolls focused inputs into view within the given container.
 * Elements with the `data-keyboard-scroll` attribute are also supported.
 */
export const useFocusIntoView = (
  containerRef: React.RefObject<HTMLElement>
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleFocus = (event: FocusEvent) => {
      const target = event.target as HTMLElement | null;
      if (
        target instanceof HTMLInputElement ||
        target?.dataset.keyboardScroll !== undefined
      ) {
        setTimeout(() => {
          target.scrollIntoView({
            block: "nearest",
            behavior: "smooth",
          });
        }, 75);
      }
    };

    container.addEventListener("focusin", handleFocus);
    return () => {
      container.removeEventListener("focusin", handleFocus);
    };
  }, [containerRef]);
};
